import React from 'react';
import { Container } from "@mui/material";
import DashboardTabs from './tabs/dashboard.tabs';
const StudentDashboardComponent = ({setLoginToken})=>{
    return(
        <Container maxWidth={false}
            disableGutters
            sx={{
                // backgroundColor: "red",
                // padding : "80px",
                border: '1px solid black'
            }}
        >
            <DashboardTabs setLoginToken={setLoginToken}/>
        </Container>
    );
}
export default StudentDashboardComponent;